<template>
  <Collapse
    v-if="canRead || isTenant"
    :title="$t('tenantProjects.deposit')"
  >
    <div
      slot="content"
      class="projectControl__deposit"
    >
      <DepositAmount
        ref="depositAmount"
        :canUpdate="canUpdate"
        :canNotifyAccounting="canNotifyAccounting"
        :canRead="canRead"
        :chequeFiles="chequeFiles"
        @dirty-state-change="notifyDirtyStateChange"
      />
      <hr v-if="isShowRefund">
      <RefundAmount
        v-if="isShowRefund"
        ref="refundAmount"
        :canUpdate="canUpdate"
        :canNotifyAccounting="canNotifyAccounting"
        @dirty-state-change="notifyDirtyStateChange"
      />
      <div
        v-show="!isTenant && isShowDepositAttachment"
        class="deposit-upload"
      >
        <hr>
        <p
          v-if="isShowDepositAttachment"
          class="title blod-p"
        >
          {{ $t('tenantProjects.depositDocTitle') }}
          <span class="internal">({{ $t('internalUseOnly') }})</span>
        </p>
        <HkldDropzone
          v-if="sourceId && canUpdate"
          :sourceId="sourceId"
        />
        <EditAttachments
          v-if="sourceId"
          ref="editAttachments"
          :sourceId="sourceId"
          :canDownloadAll="false"
          :canEdit="canUpdate"
          :canDelete="canUpdate"
          :getFilesList="getFilesList"
          :attachmentTypes="attachmentTypes"
        />
      </div>
    </div>
  </Collapse>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import Collapse from '@/controls/Collapse'
import EditAttachments from '@/controls/EditAttachments'
import HkldDropzone from '@/controls/HkldDropzone'
import { utils as formUtils } from '@/plugin/InputChange'
import { aclHelper, tmsPermsTypes } from '@/utils/aclHelper'
import RefundAmount from './RefundAmount'
import DepositAmount from './DepositAmount'
import { depositDocTypes } from './consts'
import { syncSaveDepositAmountBatch } from './sync.service'
import { FORM_SRC_PROJECT_CONTROL } from '../consts'

export default {
  name: 'DepositIndex',
  components: {
    Collapse,
    DepositAmount,
    EditAttachments,
    HkldDropzone,
    RefundAmount,
  },
  data () {
    return {
      filesLength: 0,
      chequeFiles: [],
      attachmentTypes: [{
        typeName: this.$t('project.docs.attachment'),
        attrName: depositDocTypes.cheque,
      }],
    }
  },
  computed: {
    ...mapGetters('user', ['isTenant']),
    ...mapGetters('tenantProject', ['currentTenantProject', 'refund', 'deposit']),
    sourceId () {
      return deep(this.deposit, 'sourceId')
    },
    hasDepositAmount () {
      return get(this.deposit, 'amount')
    },
    canRead () {
      return aclHelper.getAccess(tmsPermsTypes.project.readDeposit)
    },
    canUpdate () {
      return aclHelper.getAccess(tmsPermsTypes.project.updateDeposit)
    },
    canNotifyAccounting () {
      return aclHelper.getAccess(tmsPermsTypes.project.notifyAccounting)
    },
    isShowRefund () {
      return this.isTenant ? this.isDepositrNotifiedToAccounting && this.hasDepositAmount : this.isDepositrNotifiedToAccounting && this.isRefundRequested
    },
    isRefundRequested () {
      return get(this, 'refund.requestedAt')
    },
    isDepositrNotifiedToAccounting () {
      const actionHistory = get(this.deposit, 'actionHistory', [])
      return actionHistory.some((item) => item.actionType === 'notifyAccounting')
    },
    isShowDepositAttachment () {
      return this.canUpdate || (this.canRead && this.filesLength > 0)
    },
  },
  methods: {
    ...mapActions('tenantProject', ['loadTenantProject']),
    getFilesList (files) {
      this.filesLength = files.length
      this.chequeFiles = files.filter(item => item.metaData[depositDocTypes.cheque])
    },
    hasDirtySaveFields () {
      return ['depositAmount', 'refundAmount']
        .map(refName => this.$refs[refName])
        .filter(Boolean)
        .some(component => component.hasDirtySaveFields && component.hasDirtySaveFields())
    },
    notifyDirtyStateChange () {
      this.$emit('dirty-state-change')
    },
    async saveAndContinueLeave ({ deferFinalize = false } = {}) {
      const components = ['depositAmount', 'refundAmount']
        .map(refName => this.$refs[refName])
        .filter(Boolean)

      return syncSaveDepositAmountBatch({
        components,
        reloadProject: deferFinalize ? () => Promise.resolve() : () => this.loadTenantProject(this.$route.params.id),
        resetDirty: deferFinalize ? () => undefined : () => formUtils.resetDirty(FORM_SRC_PROJECT_CONTROL),
        onSaveSuccess: (dirtyComponents) => {
          dirtyComponents.forEach(component => {
            component.isEditingAmount = false
          })
        },
      })
    },
  },
}
</script>

<style lang='scss'>
  .projectControl__deposit {
    padding: 20px;
    input[type="radio"] {
      cursor: pointer;
      height: 18px;
      width: 18px;
      display: inline-block;
      vertical-align: middle;
    }
    input {
      margin-bottom: 0px !important;
    }
    .deposit-upload {
      p.title {
        margin-bottom: 15px;
      }
    }
  }
  .blod-p {
    font-weight: bold;
    margin-bottom: 0;
    height: 25px;
  }
  .medium-size {
    font-size: 16px !important;
  }
  .gray-font {
    font-size: 12px;
    color: #878787;
    display: inline-block;
    height: 20px
  }
  .margin-left-15 {
    margin-left: 15px;
  }
  .margin-right-15 {
    margin-right: 15px;
  }
</style>
